import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="Yapay zekâ komutu nedir" className="bg-transparent" data-id="element-220" data-mp="3mkdfzmsnfz7t">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: '20px',
      paddingBottom: '24px'
    }} data-id="element-221" data-mp="37nmgzemw0piq">
        <div className="text-center" data-id="element-222" data-mp="3cmh9j8anpsg1">
          <h2 className="font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-223" data-mp="3cnildezhyiyt">Yapay zekâ komutu (prompt) nedir?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-plum/70" data-id="element-224" data-mp="2yosnhx4usf9e">
            Bir prompt, yapay zekâya hangi görevi gerçekleştirmesi gerektiğini açıklayan <span className="font-bold text-grape" data-id="element-225" data-mp="wv1rtbf8nhbl">yapılandırılmış bir talimattır</span>.
          </p>
        </div>

        <PromptFlow data-id="element-226" data-mp="11tms1auhq101" />
        <PromptDemo data-id="element-227" data-mp="11u5z1wilr4za" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-228" data-mp="11sldgwe9mwdk">
          <h3 className="text-center font-display text-xl font-black text-plum sm:text-2xl" data-id="element-229" data-mp="30h5xlxhzhxvr">Profesyonel sonuç için yapılandırılmış komut örnekleri</h3>
          <p className="mt-2 text-center text-sm text-plum/60" data-id="element-230" data-mp="2wej9o7ofox3u">Bilgilerinizi özelleştirin ve komutu kopyalayın.</p>

          <div role="tablist" aria-label="Komut örnekleri" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-231" data-mp="358nyklk0bygq">
            {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-plum text-white' : 'border border-grape/20 bg-white text-plum/70 hover:text-plum'}`} data-id="element-232" data-mp="2hjld12m95lgy" data-mpi={i}>
                Komut {String(sp.n).padStart(2, '0')} · {sp.title}
              </button>)}
          </div>

          <div className="mt-5" role="tabpanel" data-id="element-233" data-mp="9upqa0spmdyr">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-234" data-mp="dtgqwhwdwdqm" />
          </div>
        </div>
      </div>
    </section>;
}